(function () {
	'use strict';

	if (typeof IntersectionObserver !== 'undefined') {
		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					entry.target.setAttribute('src', entry.target.dataset.src);
					entry.target.classList.add('loaded');
				}
			});
		}, {threshold: .05});

		document.querySelectorAll('img[data-src]').forEach(function (el) {
			observer.observe(el)
		});
	}
	else {
		document.querySelectorAll('img[data-src]').forEach(function (el) {
			el.setAttribute('src', el.dataset.src);
		});
	}
})();
